import React from "react";
import { StatefulToolTip } from "react-portal-tooltip";

const style = {
  style: {
    background: "var(--background-color)",
    padding: "0.5rem 1rem",
    fontSize: "11px",
    color: "var(--tooltip-color)",
    borderColor: "var(--tooltip-border-color)",
    maxWidth: "200px",
  },
  arrowStyle: {
    color: "var(--background-color)",
    borderColor: false,
  },
};

const styleNotes = {
  style: {
    background: "var(--background-color)",
    padding: 5,
    boxShadow: "5px 5px 3px rgba(0,0,0,.5)",
    wordBreak: "normal",
    whiteSpace: "pre-line",
    fontSize: "13px",
    fontWeight: 500,
    color: "var(--primary)",
    maxWidth: "200px",
  },
  arrowStyle: {
    color: "var(--background-color)",
    borderColor: false,
  },
};
const styleOnboarding = {
  style: {
    background: "var(--background-color)",
    padding: "5px 10px",
    width: "200px",
    textAlign: "center",
    boxShadow: "5px 5px 3px rgba(0,0,0,.5)",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 500,
    color: "var(--primary)",
  },
  arrowStyle: {
    color: "var(--background-color)",
    borderColor: false,
  },
};

const TooltipPortal = ({
  forOnboarding,
  forNotes,
  children,
  body,
  childrenContainerClass,
  position = "bottom",
  timeOut = 1,
}) => (
  <StatefulToolTip
    position={position}
    arrow="center"
    tooltipTimeout={timeOut}
    parent={children}
    className={childrenContainerClass}
    style={forNotes ? styleNotes : forOnboarding ? styleOnboarding : style}
  >
    {body}
  </StatefulToolTip>
);

export default TooltipPortal;
